// * This utility sets titlebar spacing for PWAs using the Window Controls Overlay feature.
// * It feature-detects support for the feature and adds a class to the body if supported.
// * This should be loaded before mounting the app
const windowControlsOverlay = () => {
  const checkOverlaySupport = () => {
    try {
      // Don't check during orientation changes to avoid conflicts
      if (document.documentElement.classList.contains("orientation-changing")) {
        console.log("Skipping window controls overlay check during orientation change");
        return;
      }

      if (
        typeof window !== "undefined" &&
        window.matchMedia &&
        window.matchMedia("(display-mode: standalone)").matches
      ) {
        const supportsOverlay =
          typeof CSS !== "undefined" &&
          CSS.supports &&
          (CSS.supports("height: env(titlebar-area-height)") ||
            CSS.supports("padding-left: env(titlebar-area-inset-left)"));

        if (supportsOverlay) {
          document.body.classList.add("window-controls-overlay");
        } else {
          document.body.classList.remove("window-controls-overlay");
        }
      } else {
        document.body.classList.remove("window-controls-overlay");
      }
    } catch (error) {
      // Silently fail if there's an error (e.g., during orientation changes)
      console.warn("Window controls overlay check failed:", error);
      document.body.classList.remove("window-controls-overlay");
    }
  };

  // Initial check
  checkOverlaySupport();

  // Re-check on orientation changes and resize events
  if (typeof window !== "undefined") {
    let orientationTimeout: number;

    const handleOrientationChange = () => {
      // Clear any existing timeout
      clearTimeout(orientationTimeout);

      // Debounce orientation changes (they can fire rapidly)
      // Use a longer delay to avoid conflicts with orientation protection
      orientationTimeout = window.setTimeout(() => {
        checkOverlaySupport();
      }, 500); // Increased from 150ms to avoid conflicts
    };

    const handleResize = () => {
      // Debounce resize events
      clearTimeout(orientationTimeout);
      orientationTimeout = window.setTimeout(() => {
        checkOverlaySupport();
      }, 100);
    };

    window.addEventListener("orientationchange", handleOrientationChange);
    window.addEventListener("resize", handleResize);
  }
};

export default windowControlsOverlay;
